import type { DiscoveryGetTrends200PageAllOf } from './discoveryGetTrends200PageAllOf';
import type { DiscoveryGetTrends200PageAllOfThree } from './discoveryGetTrends200PageAllOfThree';

export type DiscoveryGetTrends200Page = DiscoveryGetTrends200PageAllOf & DiscoveryGetTrends200PageAllOfThree;
